import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dispatch, store } from 'store';

import { CurrentUser } from 'types/user';

const initialState: CurrentUser | null | undefined = null;

const userSlice = createSlice({
  name: 'user',
  initialState: initialState as CurrentUser | null | undefined,
  reducers: {
    setUserData(state, action: PayloadAction<CurrentUser | null>) {
      return action.payload;
    },
    updateUserData: (state, action: PayloadAction<Partial<CurrentUser>>) => {
      if (state) {
        Object.assign(state, action.payload);
      }
    },
    resetUserData: () => initialState,
  },
});

export default userSlice.reducer;
export const { setUserData, updateUserData, resetUserData } = userSlice.actions;

export async function fetchUpdateUserData(params: Partial<CurrentUser>) {
  try {
    const currentUserData = store.getState().user;
    if (!currentUserData) {
      console.warn('fetchUpdateUserData: No user data yet');
      return;
    }

    //? const updatedUserData = { ...currentUserData, ...params };
    //? const data = await fetcher('post', ['/api/services/SetCompanyConfig', { data: updatedCompanyData }], 'history');

    dispatch(updateUserData(params));
    //? if (sendNotification) {
    //   //TODO Localization
    //   enqueueSnackbar(data ? 'Success' : 'Error', {
    //     variant: data ? 'success' : 'error',
    //   });
    // }
  } catch (error) {
    console.warn('fetchUpdateCompanyData err: ', error);
    //TODO Localization
    // if (sendNotification)
    // enqueueSnackbar('Error', {
    //   variant: 'error',
    // });
  }
}
